class Config {
    constructor(){
        var self = this;

        this.GithubAPP = null;
        this.OAuth = {
            'point': 'https://github.com/login/oauth/authorize',
            'client_ids': {
                'warodai.ru': 'a2a041d8437bab76a1bc',
                'localhost': 'e5f7e0f100ddf0fd1c4d',
                'ngrok': '7c39ac003c9ba3fafb2e',
                'github.io': '7e1e161f3f375528ea15',
                'linux': '590ace4e4b07e252a23f'
            },
            'redirectURI': encodeURI(window.location.protocol+'//'+window.location.host+window.location.pathname)
        };

        //Автоматически определяем GithubApp по текущему хосту
        Object.keys(this.OAuth.client_ids).map((client)=>{
            if(window.location.host.indexOf(client) >= 0) {
                self.GithubAPP = client;
            }
        });

        this.org = 'WarodaiProject';
        this.authPoint = 'https://warodai.ru/api/v1/utils/github_auth_token/?app='+this.GithubAPP;
        this.apiGate = 'https://api.github.com';

        this.defaultArticleValidator = function(body){
            body = body.split("\n");
            var errors = [];
         
            if(body.length < 2){
                errors.push("Статья имеет менее 2 строк.");
            }
            
            var headerRegexp = /^([\u3040-\u309F\u30A0-\u30FF\u31f0-\u31ff…A-Z.,･！ ]+)(【[^】]+】)? ?(\([а-яА-ЯЁёйў*,…:\[\] \u0306-]+\)) *(\[[^\]]+\])?(〔[^〕]+〕)$/;

            if(!headerRegexp.test(body[0])){
                errors.push("Неверный формат заголовка статьи.");
            }                    
            
            return errors;
        };

        this.corpuses = {
            "warodai": {
                "disabled": false,
                "name": "WARODAI",
                "repo": 'WarodaiProject/warodai-source',
                "canAddCards": true,
                "codeStructure": '000/00/00',
                "color": '#007bff',
                "fontColor": "#ffffff",
                "articleValidator": this.defaultArticleValidator
            },
            "bjrd": {
                "disabled": false,
                "name": "БЯРС",
                "repo": 'WarodaiProject/bjrd-source',
                "imagesRepo": 'WarodaiProject/bjrd-images',
                "canAddCards": false,
                "codeStructure": '0-000/0-00',
                "imageCodeStructure": '0-000/0-00',
                "color": '#ffc107',
                "fontColor": "#000000",
                "articleValidator": this.defaultArticleValidator
            },
            "zrjiten": {
                "disabled": true,
                "name": "РЯС",
                "repo": 'WarodaiProject/zrjiten-source',
                "imagesRepo": 'WarodaiProject/zrjiten-images',
                "canAddCards": false,
                "codeStructure": '000-0/00',
                "imageCodeStructure": '000/0-00',
                "color": '#b33d5e',
                "fontColor": "#ffffff",
                "articleValidator": function(body){
                    body = body.split("\n");
                    var errors = [];
                 
                    if(body.length < 3){
                        errors.push("Статья имеет менее 3 строк.");
                    }
                    return errors;
                }
            }
        }
    }    
}

export default Config